import { createCommand } from '../../utils';
import { displayRoads, moduleName } from '../state';
import { userOrganizationQuery } from '../../authentication/queries';

export const SetDisplayRoadsFromPersistenceCommand = createCommand(
    `${moduleName}/SET_DISPLAY_ROADS_FROM_PERSISTANCE`,
    async (_, { dispatch, extra, getState }) => {
        const userOrganization = userOrganizationQuery(getState());

        if (userOrganization) {
            const organizationSettings = await extra.mapViewSettings.getSettingsByOrganizationId(userOrganization.id);
            if (typeof organizationSettings.displayRoads !== 'undefined') {
                dispatch(displayRoads(organizationSettings.displayRoads));
            }
        }
    },
);
